module.exports = __webpack_public_path__ + "static/media/attach.a556a33d.svg";